module.exports = __webpack_public_path__ + "img/restore_button_hover.20823a0b.svg";